import styled, { keyframes } from 'styled-components'
import variables from '../../styles/variables'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const countUp = keyframes`
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
`

export const Container = styled.div`
  background: linear-gradient(135deg, ${variables.colors.lightGrey} 0%, ${variables.colors.white} 100%);
  border: 2px solid ${variables.colors.primary};
  border-radius: 20px;
  padding: 2.5rem;
  margin: 2rem 0;
  animation: ${fadeInUp} 0.8s ease;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2.5rem;
`

export const Title = styled.h3`
  color: ${variables.colors.greyDarkest};
  font-family: ${variables.fonts.header};
  font-size: 1.8rem;
  margin: 0 0 1rem 0;
  font-weight: 700;
`

export const Description = styled.p`
  color: ${variables.colors.greyDark};
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  
  @media ${variables.media.sm} {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
  }
`

export const MetricCard = styled.div`
  background: ${props => props.highlight ? 
    `linear-gradient(135deg, ${variables.colors.brandPrimary} 0%, ${variables.colors.turquoiseAccent} 100%)` : 
    variables.colors.white
  };
  color: ${props => props.highlight ? variables.colors.white : variables.colors.greyDarkest};
  padding: 2rem 1.5rem;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
  transition: all 0.4s ease;
  animation: ${countUp} 0.6s ease;
  animation-delay: ${props => Math.random() * 0.3}s;
  animation-fill-mode: both;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 140px;
  
  &:hover {
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0 15px 45px rgba(0,0,0,0.15);
  }
`

export const MetricIcon = styled.div`
  margin-bottom: 1rem;
  
  img {
    width: 40px;
    height: 40px;
    filter: ${props => props.highlight ? 'brightness(0) invert(1)' : 'none'};
  }
`

export const MetricValue = styled.div`
  font-size: ${props => props.highlight ? '2.2rem' : '1.8rem'};
  font-weight: 900;
  font-family: ${variables.fonts.header};
  margin-bottom: 0.75rem;
  line-height: 1;
  word-wrap: break-word;
  hyphens: auto;
  
  @media ${variables.media.sm} {
    font-size: ${props => props.highlight ? '1.8rem' : '1.5rem'};
  }
`

export const MetricLabel = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  line-height: 1.4;
  word-wrap: break-word;
  hyphens: auto;
  
  @media ${variables.media.sm} {
    font-size: 0.75rem;
    letter-spacing: 0.1px;
  }
`